<template>
  <div>
    <b-modal
      v-model="show"
      no-close-on-backdrop
      no-close-on-esc
      id="modal-lg"
      hide-footer
      modal-class="p-0"
      body-class="p-0"
      content-class="border-0"
      header-class="border-0"
      @close="closeModal()"
      size="lg"
      ref="modal-edit"
    >
      <div style="width: 100%;text-align: end; margin-top: -20px;z-index: 3; background-color: white;position: relative;">
        <button style="height: 30px;width: 30px;margin-right: 10px; background-color: white;border-color: white; font-size: 15px;font-weight: bold; line-height: 12px;" @click="closeModal()">×</button>
      </div>
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-center">
              <h3 class="mb-4 text-center">歩数グラフ（1日）</h3>
            </div>

            <h4 class="card-title mb-4">
              <span class="color-score">{{ totalSteps }}</span
              >歩
            </h4>
            <!-- Column with Data Labels -->
            <apexchart
              class="apex-charts"
              height="450"
              type="bar"
              dir="ltr"
              :series="columnDatalabelChart.series"
              :options="columnDatalabelChart.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import { filter } from "../../helpers/Vue-Filter";

export default {
  props: ["isShow", "dateTilte", "dataSteps"],

  filters: {
    ...filter,
  },

  data() {
    return {
      show: false,
      dataArr: [],
      totalSteps: 0,
      categories: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23,
      ],
    };
  },

  components: {},

  watch: {
    dataSteps: {
      handler(data) {
        this.totalSteps = 0;
        this.dataArr = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,];

        if (data) {
          for (const step of data) {
            this.totalSteps += Math.round(step.value);
            this.dataArr[moment(step.startDate).hour()] = Math.round(step.value);
          }
        }
      },
    },

    isShow: {
      handler(flag) {
        this.show = flag;
      },
    },
  },

  created() {
    this.show = this.isShow;
  },

  computed: {
    columnDatalabelChart() {
      return {
        series: [
          {
            name: "Inflation",
            data: this.dataArr,
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
              tooltip: {
                enabled: false,
              },
            },
          },
          plotOptions: {
            bar: {
              dataLabels: {
                position: "top", // top, center, bottom
              },
            },
          },
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              if (val > 0) {
                return val;
              } else {
                return "";
              }
            },
            offsetY: -22,
            style: {
              fontSize: "12px",
              colors: ["#304758"],
            },
          },
          tooltip: {
            enabled: false,
          },
          colors: ["#556ee6"],
          grid: {
            borderColor: "#f1f1f1",
          },
          xaxis: {
            categories: this.categories,
            position: "bottom",
            labels: {
              show: true,
            },
            axisBorder: {
              show: true,
            },
            axisTicks: {
              show: false,
            },

            crosshairs: {
              fill: {
                type: "gradient",
                gradient: {
                  colorFrom: "#D8E3F0",
                  colorTo: "#BED1E6",
                  stops: [0, 100],
                  opacityFrom: 0.4,
                  opacityTo: 0.5,
                },
              },
            },
            tooltip: {
              enabled: true,
              offsetY: -35,
            },
          },
          fill: {
            gradient: {
              shade: "light",
              type: "horizontal",
              shadeIntensity: 0.25,
              gradientToColors: undefined,
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [50, 0, 100, 100],
            },
          },
          yaxis: {
            axisBorder: {
              show: true,
            },
            axisTicks: {
              show: true,
            },
            labels: {
              show: true,
            },
          },
        },
      };
    },
  },

  methods: {
    closeModal() {
      this.$emit("closeModal");
      this.dataInsert = {};
    },
  },
};
</script>

<style scoped>
::v-deep .my-class {
  background: #007e41;
  color: white;
  font-weight: 700;
  color: #ffffff;
  font-size: 20px;
}

::v-deep .ratio-16x9 .container .__cov-video-container .__cov-video {
  height: 35em !important;
}

::v-deep .ratio-16x9 .container {
  padding: 0px !important;
}

::v-deep .__cov-contrl-play-btn {
  visibility: hidden;
}

::v-deep .ratio-16x9 .container .__cov-video-container {
  border-radius: 0 0 0.25em 0.25rem !important;
}

* {
  font-family: "Noto Sans JP";
}
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

.text-button {
  font-weight: 700 !important;
}

::-webkit-input-placeholder {
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

.text-table {
  font-weight: 400 !important;
  color: #404040;
}

.text-label {
  font-weight: 500 !important;
  color: #404040;
}

.text-label-filter {
  font-weight: 700 !important;
  color: #404040 !important;
}

.text-link {
  color: #336aff;
}

.color-score {
  color: #336aff;
  font-weight: 700;
  font-size: 36px;
  margin-right: 10px;
}
</style>
